import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { CdkMenuItem } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@app/core/services/translate.service';
import { ComponentBaseComponent } from '../../component-base/component-base.component';
import { ContextMenuAction, ContextMenuScope } from '../context-menu.service';

@Component({
    selector: 'tt-context-menu-item',
    standalone: false,
    templateUrl: './context-menu-item.component.html',
    styleUrls: ['./context-menu-item.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    hostDirectives: [CdkMenuItem],
    host: {
        '[class.tt-context-menu-item--icon]': '!!icon',
        '[class.tt-context-menu-item--danger]': 'danger',
        '[class.tt-context-menu-item--divider]': 'divider',
    },
})
export class ContextMenuItemComponent extends ComponentBaseComponent implements OnChanges, OnDestroy {
    @Input() ttText = '';
    @Input() ttIcon?: string;
    @Input() set ttTranslateText(value: BooleanInput) { this.translateText = coerceBooleanProperty(value); }
    @Input() set ttDisabled(value: BooleanInput) { this.menuItem.disabled = coerceBooleanProperty(value); }
    @Input() set ttDanger(value: BooleanInput) { this.danger = coerceBooleanProperty(value); }
    @Input() set ttHasDivider(value: BooleanInput) { this.divider = coerceBooleanProperty(value); }
    @Output() ttClick = new EventEmitter<ContextMenuAction>();

    text = '';
    icon = '';
    danger = false;
    divider = false;
    private translateText = true;
    private textVersion = 0;
    private readonly triggered: Subscription;

    constructor(private menuItem: CdkMenuItem, private scope: ContextMenuScope,
        private translate: TranslateService, private changeDetector: ChangeDetectorRef) {
        super();
        this.triggered = this.menuItem.triggered.subscribe(() => {
            if (this.scope.action) this.ttClick.emit({ ...this.scope.action });
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        const value = this.ttIcon?.trim() ?? '';
        this.icon = /^fa\S*\s/.test(value) ? value : /^fa[brlsd]?-/.test(value)
            ? value.slice(0, value.indexOf('-')) + ' fa' + value.slice(value.indexOf('-')) : value ? 'glyphicon ' + value : '';
        if (changes['ttText'] || changes['ttTranslateText']) this.setText();
    }

    private async setText(): Promise<void> {
        const version = ++this.textVersion;
        this.text = this.ttText;
        this.menuItem.typeaheadLabel = this.text;
        if (this.translateText && this.ttText) {
            const text = await this.translate.translate(this.ttText);
            if (version !== this.textVersion) return;
            this.text = text;
            this.menuItem.typeaheadLabel = text;
            this.changeDetector.markForCheck();
        }
    }

    ngOnDestroy(): void {
        this.textVersion++;
        this.triggered.unsubscribe();
    }
}
